module.exports = __webpack_public_path__ + "static/media/YF87_8.5ef71909.jpg";